<template>
  <div>
  <myHeader></myHeader>

    <div class="webTarifSoins webTarifMainBloc">
      <h2>Soins énergétiques</h2>
      <div class="webTarifImg webTarifImg2">
        <img src="../../assets/PrestationSoin2.jpg" alt="Trichotherapy">
      </div>
      <br>
      <div class="webTarifSoinLink">
        <a class="webTarifTitle" @click.prevent="goTricho()"> Cliquez ici pour en savoir plus</a>
      </div>

      <h3 class="webTarifH3Style">Tarifs</h3>
      <div class="webTarifgroup">
        <div class="webTarifEntete">
          <p class="webTarifLines"></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
        </div>
        <div :key="'tarifFilterSoins' + index" v-for="(tarifFilterSoins, index) in tarifFilterSoins">
          <p @click.prevent="editTarif(tarifFilterSoins._id)" type="submit" class="webTarifNames">{{ tarifFilterSoins.name }}
          </p>
          <div class="webTarifLines">
            <p class="webTarifValues"></p>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFilterSoins.priceS" type="string" name="priceS" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFilterSoins.priceM" type="string" name="priceM" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFilterSoins.priceL" type="string" name="priceL" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFilterSoins.priceUnique" type="string" name="priceUnique" class="webTarifValues"
            disabled="disabled"></vue-numeric>
          <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
            v-model="tarifFilterSoins.priceXL" type="string" name="priceXL" class="webTarifValues"
            disabled="disabled"></vue-numeric>
        </div>
      </div>
    </div>
  </div>

  <myFooter></myFooter>
  </div>
</template>

<script>
import axios from 'axios'
import VueNumeric from 'vue-numeric'
export default {
  components: {
    VueNumeric
  },
  name: 'webTarifSoins',
  data () {
    return {
      tarif: []
    }
  },
  mounted () {
    this.getAllTarifs()
  },
  computed: {
    tarifFilterSoins () {
      return this.tarif.filter(tarif => tarif.category === 'SOINS')
    }
  },
  methods: {
    getAllTarifs () {
      axios
        .get(('https://privilegia.fr/api/tarifs'))
        .then((response) => {
          this.tarif = response.data.sort(function tri (a, b) {
            if (a.name < b.name) { return -1 }
            if (a.name === b.name) { return 0 }
            if (a.name > b.name) { return 1 }
          })
        })
    },
    goTricho () {
      this.$router.push('/Trichotherapy')
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/SiteWeb/WebTarifsSoins.vue